









import Vue from "vue";
import coreApiClient from "@/services/apis/coreApiClient";
import userManager from "@/services/userManager";
import makeSelectOptions from "@common/util/makeSelectOptions";

const eventTypes = {
  import: "Nhập kho",
  return: "Hàng trả về",
  reset: "Kiểm kê",
  transfer_in: "Chuyển kho vào",
  transfer_out: "Chuyển kho ra",
  order: "Đơn hàng",
};

export default Vue.extend({
  data() {
    return {
      self: this,
      tableOptions: null,
      userManager,
    };
  },
  methods: {
    makeTableOptions() {
      return {
        attrs: {
          "item-key": "_id",
          "sort-by": "time",
          "sort-desc": true,
        },
        content: {
          name: "FIFO",
          urlEnabled: true,
          search: {},
          displayFields: {
            eventId: {
              text: "ID sự kiện",
              sortable: true,
              hidden: true,
              options: {
                transform(value: any, item: any) {
                  return item.eventType === "import" ? value || "" : "";
                },
              },
            },
            time: {
              text: "Thời gian",
              sortable: true,
              options: {
                filter: "dateTime",
              },
            },
            product: {
              text: "Mã sản phẩm",
              options: {
                subProp: "product.sku",
                label: true,
              },
            },
            eventType: {
              text: "Loại",
              sortable: true,
              options: {
                label: true,
                transform(value: any) {
                  return eventTypes[value] || value;
                },
              },
            },
            orderId: {
              text: "ID đơn hàng xuất",
              options: {
                transform(value: any, item: any) {
                  return item.eventType === "order" ? item.order?.orderId || value || "" : "";
                },
                attrs() {
                  return { style: "white-space: nowrap" };
                },
              },
            },
            count: {
              text: "Số lượng",
              sortable: true,
              options: {
                transform(value) {
                  return value > 0 ? `+${value}` : `${value}`;
                },
                attrs(_, item) {
                  return { style: item.count > 0 ? "color: green" : "color: red" };
                },
              },
            },
            unitCost: {
              text: "Đơn giá cost/1pcs",
              sortable: true,
              options: {
                filter: "currency",
              },
            },
            totalCost: {
              text: "Thành tiền",
              sortable: true,
              options: {
                filter: "currency",
              },
            },
            importItemCount: {
              text: "Số lượng",
              options: {
                labels(_: any, item: any) {
                  return (item.importItems || []).map((i: any) => i.count);
                },
                labelsSeparatedByNewLine: true,
              },
            },
            importItemBaseCost: {
              text: "Đơn giá",
              options: {
                labels(_: any, item: any) {
                  return (item.importItems || []).map((i: any) => Vue.filter("currency")(i.baseCost));
                },
                labelsSeparatedByNewLine: true,
              },
            },
            importItemTime: {
              text: "Ngày nhập kho của lô",
              options: {
                labels(_: any, item: any) {
                  return (item.importItems || []).map((i: any) => {
                    if (!i.importTime) {
                      return "-";
                    }
                    return Vue.filter("dateTime")(i.importTime);
                  });
                },
                labelsSeparatedByNewLine: true,
              },
            },
            importItemPurchaseCommandOrderId: {
              text: "ID lô hàng nhập",
              options: {
                labels(_: any, item: any) {
                  return (item.importItems || []).map((i: any) => {
                    const orderId = i.purchaseCommand?.orderId;
                    return {
                      value: orderId || "-",
                      attrs: {
                        "data-purchasecommand-chip": "1",
                        ...(orderId ? { "data-purchasecommand-id": orderId } : {}),
                        style: "white-space: nowrap",
                      },
                    };
                  });
                },
                labelsSeparatedByNewLine: true,
              },
            },
            importItemDuration: {
              text: "Số ngày lưu kho",
              options: {
                labels(_: any, item: any) {
                  return (item.importItems || []).map((i: any) => {
                    if (!i.importTime) {
                      return "-";
                    }
                    const endTime = i.lastExportedTime != null ? i.lastExportedTime : item.eventType !== "import" ? item.time : null;
                    if (endTime == null) {
                      return "-";
                    }
                    const days = Math.floor((endTime - i.importTime) / 86400000);
                    return `${days} ngày`;
                  });
                },
                labelsSeparatedByNewLine: true,
              },
            },
            runningStock: {
              text: "Tồn lũy kế của lô nhập",
              options: {
                labels(_: any, item: any) {
                  if (item.eventType !== "order") {
                    return [];
                  }
                  return (item.importItems || []).filter((i: any) => i.remainingCount !== undefined && i.remainingCount !== null).map((i: any) => i.remainingCount);
                },
                labelsSeparatedByNewLine: true,
              },
            },
            runningStockTotal: {
              text: "Số lượng tồn kho",
              sortable: false, // virtual display key — server would sort by "runningStockTotal" which doesn't exist in DB
              options: {
                transform(_: any, item: any) {
                  return item.runningStock != null ? item.runningStock : "";
                },
              },
            },
            runningStockValue: {
              text: "Giá trị tồn kho",
              sortable: true,
              options: {
                filter: "currency",
              },
            },
            calculatedTime: {
              text: "Thời gian tính",
              sortable: true,
              options: {
                filter: "dateTime",
              },
            },
          },
          filters: {
            filters: {
              productId: {
                type: "XAutocomplete",
                attrs: {
                  label: "Sản phẩm",
                  required: true,
                  "item-value": "_id",
                  "item-text": "sku",
                  xOptions: {
                    content: {
                      async itemsSuggestor(search, value, limit) {
                        const { items } = await coreApiClient.call("products", "findAll", {
                          payload: JSON.stringify({
                            search,
                            limit,
                            filters: value ? [{ key: "_id", operator: "equal_to", value }] : [],
                          }),
                        });
                        return items;
                      },
                    },
                  },
                },
                rules: {
                  equal_to: {},
                },
              },
              eventType: {
                type: "select",
                attrs: {
                  label: "Loại",
                  multiple: true,
                  items: makeSelectOptions(eventTypes),
                },
                rules: {
                  in: {},
                },
              },
              time: {
                type: "XDateTimePicker",
                rules: {
                  greater_than_or_equal_to: {
                    attrs: {
                      label: "Thời gian (bắt đầu)",
                    },
                  },
                  less_than_or_equal_to: {
                    attrs: {
                      label: "Thời gian (kết thúc)",
                    },
                  },
                },
              },
              orderOrderId: {
                type: "text",
                attrs: {
                  label: "ID đơn hàng xuất",
                },
                rules: {
                  equal_to: {},
                },
              },
              importItemPurchaseCommandOrderId: {
                type: "text",
                attrs: {
                  label: "ID lô hàng nhập",
                },
                rules: {
                  equal_to: {},
                },
              },
            },
          },
          template: {
            itemActionButtons: {},
          },
        },
        ext: {
          dataProvider: {
            async findAll(options) {
              const { items, count } = await coreApiClient.call("fifoLedgerEntries", "findAll", options);
              return [items, count];
            },
          },
        },
      };
    },
    onPurchaseCommandChipClick(e: MouseEvent) {
      const chip = (e.target as HTMLElement).closest("[data-purchasecommand-chip]");
      this.$el.querySelectorAll("tr.fifo-highlighted-row").forEach((tr: Element) => {
        tr.classList.remove("fifo-highlighted-row");
      });
      if (!chip) {
        return;
      }
      const orderId = (chip as HTMLElement).dataset.purchasecommandId;
      if (orderId) {
        this.$el.querySelectorAll(`[data-purchasecommand-id="${orderId}"]`).forEach((el: Element) => {
          el.closest("tr")?.classList.add("fifo-highlighted-row");
        });
      } else {
        chip.closest("tr")?.classList.add("fifo-highlighted-row");
      }
    },
  },
  async created() {
    this.tableOptions = this.makeTableOptions();
  },
});
